import { useState } from 'react';
import { CurrencyTypeEnum } from '../../../../../../model/currency_type.enum';
import { OptionConfig, WindowTenorEnum } from './use-series-manager';

const formatTokenLabel = (token: string) => token.replace(/(_)?(USDC|USDT|USD)$/g, '');

const TOKENS = [
  CurrencyTypeEnum.BITCOIN,
  CurrencyTypeEnum.ETHEREUM,
  CurrencyTypeEnum.XRP,
  CurrencyTypeEnum.SOL,
];

export enum DeltaTypeEnum {
  ATMF = 'ATMF',
  P10 = '10P',
  P25 = '25P',
  C25 = '25C',
  C10 = '10C',
  RR25 = '25RR',
  RR10 = '10RR',
  FLY25 = '25FLY',
  FLY10 = '10FLY',
}

export type VolatilityOptionsArray = [
  OptionConfig<CurrencyTypeEnum>,
  OptionConfig<WindowTenorEnum>,
  OptionConfig<DeltaTypeEnum>,
];

export const useVolatilityOptions = () => {
  const [token, setToken] = useState<CurrencyTypeEnum>(CurrencyTypeEnum.BITCOIN);
  const [tenor, setTenor] = useState<WindowTenorEnum>(WindowTenorEnum.W1);
  const [delta, setDelta] = useState<DeltaTypeEnum>(DeltaTypeEnum.ATMF);

  const tokenOptions = TOKENS.map((t) => ({
    label: formatTokenLabel(t),
    value: t,
  }));

  const tenorOptions = [
    { label: '1W', value: WindowTenorEnum.W1 },
    { label: '2W', value: WindowTenorEnum.W2 },
    { label: '1M', value: WindowTenorEnum.M1 },
    { label: '3M', value: WindowTenorEnum.M3 },
    { label: '9M', value: WindowTenorEnum.M9 },
  ];

  const deltaOptions = [
    { label: 'ATMF', value: DeltaTypeEnum.ATMF },
    { label: '10P', value: DeltaTypeEnum.P10 },
    { label: '25P', value: DeltaTypeEnum.P25 },
    { label: '25C', value: DeltaTypeEnum.C25 },
    { label: '10C', value: DeltaTypeEnum.C10 },
    { label: '25RR', value: DeltaTypeEnum.RR25 },
    { label: '10RR', value: DeltaTypeEnum.RR10 },
    { label: '25FLY', value: DeltaTypeEnum.FLY25 },
    { label: '10FLY', value: DeltaTypeEnum.FLY10 },
  ];

  const options: VolatilityOptionsArray = [
    { key: 'token', value: token, setValue: setToken, label: 'Token', options: tokenOptions },
    { key: 'tenor', value: tenor, setValue: setTenor, label: 'Tenor', options: tenorOptions },
    { key: 'delta', value: delta, setValue: setDelta, label: 'Delta', options: deltaOptions },
  ];

  return {
    options,
  };
};
